import { Reveal } from "../../components/Reveal";
import SectionNav from "../../components/SectionNav";
import { PageHero, SectionHead, CtaBand } from "../../components/ui";
import Marquee from "../../components/Marquee";
import { PARTNERS, PARTNER_CATEGORIES } from "../../data/site";

const PARTNER_SECTIONS = [
    { id: "partners-categories", label: "Partners & stakeholders" },
    { id: "partner-register", label: "Partner register" },
];

export default function Partners() {
    return (
        <>
            <PageHero
                eyebrow="Company — Partners & Stakeholders"
                lines={["Delivered with Europe's", "energy institutions."]}
                trail={[{ label: "Home", path: "/" }, { label: "Company" }, { label: "Partners & Stakeholders" }]}
            />
            <SectionNav items={PARTNER_SECTIONS} navKey="partners" />
            <section id="partners-categories" className="bg-paper">
                <div className="container-x grid gap-12 py-20 sm:py-24 lg:grid-cols-2 lg:py-28">
                    {PARTNER_CATEGORIES.map((c, i) => (
                        <Reveal key={c.title} delay={i * 0.1}>
                            <div className="flex h-full flex-col border-t-2 border-ink pt-6">
                                <h3 className="h3-compact">{c.title}</h3>
                                <p className="body-lg mt-4 flex-1">{c.body}</p>
                                {c.list.length > 0 && (
                                    <ul className="mt-8 flex flex-wrap gap-x-8 gap-y-3 border-t border-line pt-6">
                                        {c.list.map((p) => (
                                            <li key={p} className="font-display text-base font-semibold uppercase tracking-[0.12em] text-ink-2">
                                                {p}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>
            <section id="partner-register" className="bg-white py-14 sm:py-16">
                <div className="container-x">
                    <SectionHead
                        eyebrow="Partner register"
                        title="A monochrome register, updated as partners are approved."
                    />
                </div>
                <div className="mt-12">
                    <Marquee items={PARTNERS} />
                </div>
                <div className="container-x">
                    <Reveal>
                        <p className="body-sm mt-8">
                            The partner strip is designed to expand as additional partners and
                            stakeholders are approved for publication.
                        </p>
                    </Reveal>
                </div>
            </section>
            <CtaBand />
        </>
    );
}
